import './index.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import NotFound from './NotFound';

function App() {
  return (
    <Router>
      <Routes>
        {/* Main Portfolio Route */}
        <Route path="/" element={<HomePage />} />

        {/* This matches anything that doesn't match the routes above */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
